<template>
    <div class="langs_div_class" v-if="enabled">
        <select id="select_lang" v-model="selected" name="select_lang" class="langs_select_class">
            <option
                v-for="(lang, index) in languages_options"
                :key="index"
            >
                {{ lang }}
            </option>
        </select>
    </div>
</template>
<script>
export default {
    props: ["langs", "enabled","theme","langs_meta"],
    data() {
        return {
            selected: "",
            languages_options:[]
        };
    },
    mounted() {
        console.log('this.langs',this.langs,'this.enabled',this.enabled,'this.theme',this.theme);
        if (!this.enabled&&this.langs&&this.langs.default_language) {
            //不开启语言选择器时，使用默认语言
            this.selected = this.langs.default_language;
            // localStorage.setItem(this.theme+"_locale", this.langs.default_language);
        } else if(this.enabled&&this.langs&&this.langs.select_languages&&this.langs.default_language&&this.langs_meta.options_languages) {
            this.languages_options=this.langs.all_language? this.langs_meta.options_languages:this.langs.select_languages;
            //判断已选语言是否包含缓存在localStorage里的语言
            let flag = this.languages_options.includes(localStorage.getItem(this.theme+"_locale"));
            if (flag) {
                //开启语言选择器时,先使用localStorage缓存的语言选项(如有),否则使用默认语言
                this.selected =
                    localStorage.getItem(this.theme+"_locale") ||
                    this.langs.default_language;
            } else {
                //如果已选语言不包含缓存在localStorage里的语言
                this.selected = this.langs.default_language;
                // localStorage.setItem(this.theme+"_locale", this.langs.default_language);
            }
        }else{
            this.selected="English";
            localStorage.removeItem('locale');
            localStorage.removeItem(this.theme+"_locale");
        }
    },
    watch: {
        selected(val, oldval) {
            if (val != oldval) {
                this.$i18n.locale = val;
                localStorage.setItem(this.theme+"_locale", val);//允许切换主题时使用不一致的语言
                localStorage.setItem("locale", val);//app.js初始化时使用，避免在venue设置了语言，到结账页面不生效
            }
        }
    },
    // methods: {
    //     changeLocale(lang) {
    //         this.$i18n.locale = lang;
    //         localStorage.setItem(this.theme+"_locale", lang);
    //         localStorage.setItem("locale", lang);
    //     }
    // }
};
</script>
<style scoped lang="scss">
.langs_div_class {
    height: 25px;
    margin-top: 5px;
    margin-bottom: 5px;
    position: relative;

    .langs_select_class {
        // margin: auto;
        width: 100px;
        color: #989191;
        border: 1px solid #F1F1F0;
        border-radius: 5px;
        outline: none;
    }
}
@media screen and (max-width: 768px) {
  .langs_select_class {
      margin: auto;
  }
}
</style>
